import { Box } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import React from "react";
import renderHTML from "react-render-html";
import "react-toastify/dist/ReactToastify.css";
import { reusableFn } from "../../components/reusableComponents/reusableFn";
import {
  DAMAGE_REMARK,
  LABEL_COPAYMENT,
  LABEL_ESTIMATED_BY,
  LABEL_IMEI_NUMBER,
  LABEL_JOB_SHEET_NUMBER,
  LABEL_PRODUCT,
  LABEL_UTR_NUMBER,
  SERVICE_CENTRE_NAME,
} from "../../constants/";
import { useStyles } from "./styles";

function AdditionalDetails({ classes: { question }, item }) {
  const renderText = (label, text) => {
    return renderHTML(`<Box className=${question}>${label}: </Box> ${text}`);
  };

  return (
    <Box>
      {item?.service_centre_name &&
        renderText(SERVICE_CENTRE_NAME, item?.service_centre_name)}
      <br />
      {item?.copayment_amount > 0 && (
        <>
          {renderHTML(
            `<Box className=${question}>${LABEL_COPAYMENT}: </Box> ₹${Number(
              item?.copayment_amount
            ).toLocaleString("en")}`
          )}{" "}
          <br />
        </>
      )}
      {item?.product && renderText(LABEL_PRODUCT, item?.product)}
      <br />
      {item?.imei_number && renderText(LABEL_IMEI_NUMBER, item?.imei_number)}
      <br />
      {item?.data &&
        renderText(
          DAMAGE_REMARK,
          item?.data?.inputs?.damage_details === undefined
            ? ""
            : reusableFn(item?.data?.inputs?.damage_details, 50)
        )}

      {/* <br />
      {item?.service_centre_name &&
        renderText(LABEL_PREFERRED, item?.service_centre_name)} */}
      <br />
      {item?.estimated_by_name &&
        renderText(LABEL_ESTIMATED_BY, item?.estimated_by_name)}
      <br />
      {item?.data?.inputs?.job_sheet_number &&
        renderText(
          LABEL_JOB_SHEET_NUMBER,
          item?.data?.inputs?.job_sheet_number
        )}
      <br />
      {item?.utr_number && renderText(LABEL_UTR_NUMBER, item?.utr_number)}
      <br />

      <br />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(AdditionalDetails);
